<template>
    <!-- UI-06: placeholder puro. Nessun dato, nessuna azione, nessun endpoint:
         la card dichiara solo "in sviluppo". Il contenuto non e' un mock. -->
    <div class="card in-sviluppo-card h-100 w-100 mb-2">
        <div class="card-header">
            <h3 class="card-title mb-0">In sviluppo</h3>
        </div>
        <!-- card-body e' gia' flex:1 1 auto in Bootstrap 5: occupa tutta l'altezza
             residua della card, quindi il blocco si centra senza altezze fisse. -->
        <div class="card-body d-flex align-items-center justify-content-center text-center">
            <div>
                <i class="fas fa-cogs in-sviluppo-icona" aria-hidden="true"></i>
                <p class="text-muted mb-0 in-sviluppo-testo">Box in fase di sviluppo</p>
            </div>
        </div>
    </div>
</template>

<script>
/* UI-06 - Card placeholder "In sviluppo".
 *
 * NESSUNA PROPRIETA', NESSUN PROP, NESSUN EVENTO, NESSUNA CHIAMATA API.
 * Esiste solo per occupare la colonna destra della Row 2 con lo stesso
 * aspetto delle card reali della Dashboard. Il contenuto non verrà sviluppato
 * in questa fase.
 *
 * Icona: Font Awesome 5 gia' presente nel progetto (fonts-awesome-all.css,
 * caricato in main.js) - nessuna dipendenza nuova.
 */
export default {
    name: "InSviluppoCard",
};
</script>

<style scoped>
/* h-100/w-100 sono le classi Bootstrap usate anche da TrendChart: la colonna e'
   d-flex, quindi la card si estende all'altezza della colonna (stessa altezza
   delle due card della Row 2) senza alcun'altezza in pixel. */
.in-sviluppo-icona {
    font-size: 3rem;
    line-height: 1;
    color: #cbd5e1; /* grigio chiaro, come gli altri elementi "muted" */
}
.in-sviluppo-testo {
    font-size: 0.875rem;
    margin-top: 0.75rem;
}
</style>
